module.exports = __webpack_public_path__ + "static/img/service_h5_04_zh.6b7a141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_h5_04_zh.png
// module id = VZ2U
// module chunks = 34